import { IOktaConfig } from './environment.interface';

const OKTA_MAIN = 'https://wmg.okta.com';
const OKTA_DEV = 'https://wmg.oktapreview.com';
const PROD_ISSUER = 'ausesb2is3J5sJ1H32p7';
const STG_ISSUER = 'ausesb2is3J5sJ1H32p7';
const DEV_ISSUER = 'aus13ojz5upt7FmTb0h8';

const PROD_CLIENT_ID = '0oa4d3lrbvr0Kqsgy2p7';
const STG_CLIENT_ID = '0oa4d3qtm4LToOmtP2p7';
const DEV_CLIENT_ID = '0oakosyhwuk47LE1j0h7';

const PROD_URL = `${OKTA_MAIN}/oauth2/${PROD_ISSUER}`;
const STG_URL = `${OKTA_MAIN}/oauth2/${STG_ISSUER}`;
const DEV_URL = `${OKTA_DEV}/oauth2/${DEV_ISSUER}`;

const PROD_REDIRECT_URL = 'https://sync.wmg.com/implicit/callback';
const SCOPES = ['openid', 'profile', 'groups', 'offline_access'];

const getFallBackStorage = () => {
  const storage = new Map<string, any>();
  return {
    getItem: key => storage.get(key),
    setItem: (key, value) => storage.set(key, value),
  };
};

const getDefaultOktaConfig = (): IOktaConfig => {
  return {
    url: `${PROD_URL}/oauth2/${PROD_ISSUER}`,
    issuer: PROD_URL,
    clientId: PROD_CLIENT_ID,
    responseType: 'code',
    scopes: SCOPES,
    redirectUri: PROD_REDIRECT_URL,
    tokenManager: {
      autoRenew: true,
      secure: true,
      storage: window?.localStorage || getFallBackStorage(),
    },
  };
};

export const PROD_CONFIG: IOktaConfig = {
  ...getDefaultOktaConfig(),
};

export const STG_CONFIG: IOktaConfig = {
  ...getDefaultOktaConfig(),
  url: STG_URL,
  issuer: STG_URL,
  clientId: STG_CLIENT_ID,
};

export const DEV_CONFIG: IOktaConfig = {
  ...getDefaultOktaConfig(),
  url: DEV_URL,
  issuer: DEV_URL,
  clientId: DEV_CLIENT_ID,
};
